<script>
    import * as animateScroll from "svelte-scrollto";
    import { onMount } from 'svelte';
    export let subSelection;
	

    let open3 = 1;
    let open4 = 1;

    let handleClickCertCardOne = () => {
        open3 = 1;
    }
    let handleClickCertCardTwo = () => {
        open3 = 2;
    }
    let handleClickCertCardThree = () => {
        open3 = 3;
    }
    let handleClickCertCardFour = () => {
        open3 = 4;
    }
    let handleClickCertCardFive = () => {
        open3 = 5;
    }
    let handleClickCertCardSix = () => {
        open3 = 6;
    }

    let handleClickCertBase4One = () => {
        open4 = 1;
    }
    let handleClickCertBase4Two = () => {
        open4 = 2;
    }

    let item3;
    let item4;

    let op = 1;
    let op2 = 1;

    const interval = setInterval(() => {
        if(op <= 0){
            op = 0;
            op2 = 0;
            clearInterval(interval);
        }
        op -= 0.05;
    }, 65)
    let height1 = 0;
    let height2 = 0;
    onMount(async () => {
         if(subSelection == 0)  animateScroll.scrollToTop();
        else animateScroll.scrollTo({element: '#about-section-' + subSelection, offset: -80});
        item3.click();
        item4.click();

    })

    let w;
    let h;

    let y, innerHeight;
    let row2, row2Image, calculatedRow2Start, translate2Calculated, conditionRow2;
    let row4, row4Image, calculatedRow4Start, translate4Calculated, conditionRow4;
    let row5, row5Image, calculatedRow5Start, translate5Calculated, conditionRow5;

    $: if (y) {
        calculatedRow2Start = row2.getBoundingClientRect().y - innerHeight/2;
        conditionRow2 = row2Image.getBoundingClientRect().width*0.3 + calculatedRow2Start > 0;
        translate2Calculated = conditionRow2 ? Math.pow(row2Image.getBoundingClientRect().width*0.2 + calculatedRow2Start, 2) : 0;

        calculatedRow4Start = row4.getBoundingClientRect().y - innerHeight/2;
        conditionRow4 = row4Image.getBoundingClientRect().width*0.3 + calculatedRow4Start > 0;
        translate4Calculated = conditionRow4 ? Math.pow(row4Image.getBoundingClientRect().width*0.3 + calculatedRow4Start, 2) : 0;

        calculatedRow5Start = row5.getBoundingClientRect().y - innerHeight/2;
        conditionRow5 = row5Image.getBoundingClientRect().width*0.34 + calculatedRow5Start > 0;
        translate5Calculated = conditionRow5 ? Math.pow(row5Image.getBoundingClientRect().width*0.34 + calculatedRow5Start, 2) : 0;
    }

    import Icon from 'fa-svelte';
    import { faSortUp } from '@fortawesome/free-solid-svg-icons/faSortUp';
    import { faSortDown } from '@fortawesome/free-solid-svg-icons/faSortDown';

    let up1 = true;
    let up2 = true;

    let handleClickArrow1 = () => {
        up1 = !up1;
        up2 = true;
    }
    let handleClickArrow2 = () => {
        up2 = !up2;
        up1 = true;
    }


</script>

<svelte:window bind:scrollY={y} bind:innerHeight={innerHeight}/>

<div class="row">
    <div class="col-12 white-bg" style="overflow:hidden">
        <img src="./img/background-A.svg" alt="" class="background-right disabe-img">
        <div class="row">
            <img src="./img/certification/mano-croquis.png" alt="" class="world03-base01-hand disabe-img"
                style="-webkit-mask-image: -webkit-gradient(linear, center top, center bottom,
                       color-stop({op},  rgba(0,0,0,0)),
                       color-stop({op2},  rgba(0,0,0,1)))"
            >
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix">
                <h2 class="text-content title-content section-cvs" style="margin: 20px 0 0 0;"> ETAPAS </h2>
                <hr class="underline-content">
            </div>
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix">
                <p class="text-content text-width-4">
                    La CVS posee dos etapas:
                </p>
                <ol class="text-content text-width-4" style="font-family: 'DINPro-Medium' !important;margin-bottom:0;font-size:16pt;">
                    <li>PRECERTIFICACIÓN – ETAPA DE DISEÑO</li>
                </ol>
                <ul class="list-content text-width-4" style="margin-bottom:0;padding-right:0;">
                    <li>Se obtiene contra Permiso de Edificación</li>
                    <li>
                        Consiste en una evaluación temprana,
                        únicamente de los requerimientos de la fase de
                        diseño de un proyecto.
                    </li>
                    <li>
                        Se utiliza para promover la incorporación
                        temprana de la CVS en proyectos residenciales.
                    </li>
                    <li>
                        Desarrolladores inmobiliarios pueden utilizarla
                        como herramienta de comunicación y marketing,
                        previo al inicio de la construcción de un proyecto.
                    </li>
                    <li>
                        La Precertificación tiene carácter transitorio, y es
                        válida hasta la recepción municipal definitiva.
                    </li>
                    <li>
                        La Precertificación no es vinculante para obtener
                        la Certificación.
                    </li>
                    <li>
                        La obtención de un nivel de Precertificación no
                        garantiza la obtención del mismo nivel en
                        Certificación.
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="col-12 white-bg" style="overflow:hidden" bind:this={row2}>
        <img src="./img/background-B.svg" alt="" class="background-left disabe-img">
        <div class="row" bind:clientWidth={w} bind:clientHeight={h}>
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix">
                <ol class="text-content text-width-4" style="font-family: 'DINPro-Medium' !important;margin-bottom:0;font-size:16pt;" start="2">
                    <li>CERTIFICACIÓN – ETAPA CONSTRUCCIÓN</li> 
                </ol>
                <ul class="list-content text-width-4" style="margin-bottom:0;padding-right:0;">
                    <li>Se obtiene contra Recepción Final de obras</li>
                    <li>
                        Consiste en una evaluación de los requerimientos
                        de las fases de diseño y construcción de un
                        proyecto.
                    </li>
                    <li>
                        La Certificación tiene carácter permanente:
                        valida el desempeño ambiental de proyectos
                        residenciales al momento de su entrega.
                    </li>
                    <li>
                        La Certificación no requiere de una
                        Precertificación, sin embargo, es altamente
                        recomendable, debido a que la incorporación de
                        criterios de diseño y construcción sustentable de
                        manera tardía suele tener mayores costos
                        económicos y logísticos.
                    </li>
                    <li>
                        Contempla la entrega de reportes, diploma de
                        certificación y acceso al registro de proyectos
                        certificados.
                    </li>
                    <li>
                        Habilita la opción de compra de una placa CVS.
                    </li>
                </ul>
                <p class="text-content text-width-4 base02-text-margin">
                    Para ambas etapas el proceso de trabajo es el mismo,
                    y se describe a continuación.
                </p>
            </div>
            <img bind:this={row2Image} src="./img/certification/shutterstock_123739609.jpg" alt="" class="world03-base02-img disabe-img"  style="{row2Image ? `transform: translateY(${translate2Calculated/2000}px)` : ''}">

        </div>
    </div>
    <div class="col-12 white-bg" style="overflow:hidden" id="about-section-1">
        <img src="./img/background-C.svg" alt="" class="background-right disabe-img">
        <div class="row">
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix">
                <h2 class="text-content title-content" style="margin-bottom:0;"> PROCESO </h2>
                <hr class="underline-content">
                <p class="text-content text-width-4">
                    El proceso de ceertificación consta de 6 pasos:
                </p>
                <div class="row d-flex align-items-center">
                    <div class="col-1 d-flex align-items-center justify-content-center left-arrow-pos">
                        <a href="#carouselExampleIndicators" role="button" data-slide="prev">
                        <div class="carousel-nav-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <path d="m88.6,121.3c0.8,0.8 1.8,1.2 2.9,1.2s2.1-0.4 2.9-1.2c1.6-1.6 1.6-4.2 0-5.8l-51-51 51-51c1.6-1.6 1.6-4.2 0-5.8s-4.2-1.6-5.8,0l-54,53.9c-1.6,1.6-1.6,4.2 0,5.8l54,53.9z"/>
                            </svg>
                        </div>
                        </a>
                    </div>
                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10">
                        <div id="carouselExampleIndicators" class="carousel slide">
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <div class="row">
                                        <div class="col-12 col-md d-flex justify-content-center">
                                            <div class="row">
                                                <div class="col-12" style="text-align-last: center;">
                                                <img bind:this={item3} on:click={handleClickCertCardOne} src="./img/icon1-D.svg" alt="" class="carousel-img clickable {open3 === 1 ? 'selected-box border-color-one' : ''}">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md d-flex justify-content-center">
                                            <div class="row">
                                                <div class="col-12" style="text-align-last: center;">
                                                <img on:click={handleClickCertCardTwo} src="./img/icon2-D.svg" alt="" class="carousel-img clickable {open3 === 2 ? 'selected-box border-color-one' : ''}">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md d-flex justify-content-center">
                                            <div class="row">
                                                <div class="col-12" style="text-align-last: center;">
                                                <img on:click={handleClickCertCardThree} src="./img/icon3-D.svg" alt="" class="clickable carousel-img {open3 === 3 ? 'selected-box border-color-one' : ''}"  >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-12 col-md d-flex justify-content-center">
                                            <div class="row">
                                                <div class="col-12" style="text-align-last: center;">
                                                    <img on:click={handleClickCertCardFour} src="./img/icon4-D.svg" alt="" class="carousel-img clickable {open3 === 4 ? 'selected-box border-color-one' : ''}" >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md d-flex justify-content-center">
                                            <div class="row">
                                                <div class="col-12" style="text-align-last: center;">
                                                    <img on:click={handleClickCertCardFive} src="./img/icon5-D.svg" alt="" class="carousel-img clickable {open3 === 5 ? 'selected-box border-color-one' : ''}" >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md d-flex  justify-content-center" >
                                            <div class="row">
                                                <div class="col-12" style="text-align-last: center;">
                                                    <img on:click={handleClickCertCardSix} src="./img/icon6-D.svg" alt="" class="clickable carousel-img {open3 === 6 ? 'selected-box border-color-one' : ''}" >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-1 d-flex align-items-center justify-content-center" style="position: absolute;right: 0;">
                        <a  href="#carouselExampleIndicators" data-slide="next">
                            <div class="carousel-nav-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <path d="m40.4,121.3c-0.8,0.8-1.8,1.2-2.9,1.2s-2.1-0.4-2.9-1.2c-1.6-1.6-1.6-4.2 0-5.8l51-51-51-51c-1.6-1.6-1.6-4.2 0-5.8 1.6-1.6 4.2-1.6 5.8,0l53.9,53.9c1.6,1.6 1.6,4.2 0,5.8l-53.9,53.9z"/>
                                </svg>
                            </div>
                        </a>
                    </div>
                </div>
                <div id="accordionCert" style="margin:2vh 0;">
                    {#if open3 == 1}
                        <div class="card" style="margin-bottom:2%;">
                          <div class="card-header" id="headingOne" style="padding:0;">
                            <h2 class="text-align-center" style="margin:0;padding:0;">
                              <p class="dropdown-header">
                                  ELECCIÓN DE UN ASESOR CVS
                              </p>
                            </h2>
                          </div>
                          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionCert">
                            <div class="card-body">
                               <p class="text-content">
                                    Un desarrollador inmobiliario que busque la Certificación deberá contratar los servicios de un Asesor CVS.
                                    Un Asesor CVS es un profesional del área de la construcción sustentable que cuenta con la experiencia y
                                    conocimientos necesarios para coordinar con el equipo de proyecto (arquitectura, instalaciones sanitarias,
                                    eléctricas, paisajismo, etc.) el cumplimiento de los requerimientos de la certificación. <br><br>
                                    Además, se encarga de recopilar toda la evidencia de cumplimiento necesaria y ponerla a disposición para su
                                    revisión.<br><br>
                                    La relación contractual entre un mandante y un Asesor CVS ocurre de manera independiente y bajo acuerdo
                                    entre dichas partes, sin intervención de <a class="link-color" href="https://ctecinnovacion.cl/">CTeC</a>. <br><br>
                                   Revisa el registro de Asesores acreditados <a class="link-color" href="/#/register"> aquí</a>
                                    
                                </p>
                            </div>
                          </div>
                        </div>
                    {/if}
                    {#if open3 == 2}
                        <div class="card" style="margin-bottom:2%;">
                          <div class="card-header" id="headingTwo" style="padding:0;">
                            <h2 class="text-align-center" style="margin:0;padding:0;">
                              <p class="dropdown-header">
                                  REGISTRO DEL PROYECTO
                              </p>
                            </h2>
                          </div>
                          <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionCert">
                            <div class="card-body">
                                  <p class="text-content">
                                    Se realiza a través de la Plataforma de Gestión Documental CVS, administrada por CTeC.<br><br>
                                    Para esto, es necesario ingresar información general sobre el proyecto y su emplazamiento, e identificar al
                                    mandante y su Asesor CVS.<br><br>
                                    Dicha tarea puede ser realizada por el mismo mandante, o ser delegada a un Asesor CVS.<br><br>
                                    Para finalizar el registro, será necesario realizar el pago de inscripción por medios electrónicos.<br><br>
                                    El registro del proyecto, habilitará el ingreso al sector de documentación el proyecto, tanto para el mandante
                                    como para el Asesor CVS.<br><br>
                                </p>
                            </div>
                          </div>
                        </div>
                    {/if}
                    {#if open3 == 3}
                        <div class="card" style="margin-bottom:2%;">
                          <div class="card-header" id="headingThree" style="padding:0;">
                            <h2 class="text-align-center" style="margin:0;padding:0;">
                              <p class="dropdown-header">
                                  RECOPILACIÓN DE DOCUMENTACIÓN
                              </p>
                            </h2>
                          </div>
                          <div id="collapseThree" class="collapse show" aria-labelledby="headingThree" data-parent="#accordionCert">
                            <div class="card-body">
                                <p class="text-content">
                                    El Asesor CVS recopilará evidencia técnica en formato digital sobre el cumplimiento de los requerimientos de
                                    la certificación. <br><br>
                                    La evidencia técnica puede estar conformada por los siguientes documentos: <br><br>
                                </p>
                                <div class="row">
                                    <div class="col-6">
                                        <ul class="list-content">
                                            <li>
                                                Planimetría
                                            </li>
                                            <li>
                                                Fichas técnicas de materiales o equipos
                                            </li>
                                            <li>
                                                Especificaciones técnicas de especialistas.
                                            </li>
                                            <li>
                                                Planillas de cálculo
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="col-6">
                                        <ul class="list-content">
                                            <li>
                                                Planillas de trazabilidad
                                            </li>
                                            <li>
                                                Memorias de cálculo realizadas por especialistas
                                            </li>
                                            <li>
                                                Certificados
                                            </li>
                                            <li>
                                                Reportes de inspección en obra
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <p class="text-content">
                                  Toda la documentación se entrega de manera digital. <b>No existe uso de papel en el proceso.</b>
                              </p>
                            </div>
                          </div>
                        </div>
                    {/if}
                    {#if open3 == 4}
                        <div class="card" style="margin-bottom:2%;">
                          <div class="card-header" id="headingFour" style="padding:0;">
                            <h2 class="text-align-center" style="margin:0;padding:0;">
                              <p class="dropdown-header">
                                  ENTREGA DE DOCUMENTACIÓN
                              </p>
                            </h2>
                          </div>
                          <div id="collapseFour" class="collapse show" aria-labelledby="headingFour" data-parent="#accordionCert">
                            <div class="card-body">
                                  <p class="text-content">
                                        Utilizando la Plataforma Técnica CVS como espacio de almacenamiento virtual, el Asesor CVS, deberá declarar
                                        a qué requerimientos postula el proyecto y adjuntar la documentación necesaria para demostrar su
                                        cumplimiento.
                                  </p>
                            </div>
                          </div>
                        </div>
                    {/if}
                    {#if open3 == 5}
                        <div class="card" style="margin-bottom:2%;">
                          <div class="card-header" id="headingFive" style="padding:0;">
                            <h2 class="text-align-center" style="margin:0;padding:0;">
                              <p class="dropdown-header">
                                   REVISIÓN DE DOCUMENTACIÓN
                              </p>
                            </h2>
                          </div>
                          <div id="collapseFive" class="collapse show" aria-labelledby="headingFive" data-parent="#accordionCert">
                            <div class="card-body">
                                  <p class="text-content">
                                        CTeC, [te direcciona a la web de CTeC] pondrá a disposición a una tercera parte, independiente e imparcial, con
                                        la experiencia necesaria para determinar si la documentación se encuentra en orden. <br><br>
                                        Los Asesores no podrán tener contacto directo ni saber la identidad de sus Revisores. <br><br>
                                        A través de un reporte de revisión, se indicará a los Asesores sobre los requerimientos que han sido
                                        correctamente documentados y aquellos que podrían necesitar de correcciones. <br><br>
                                        Las correcciones deberán ser cargadas por el Asesor a través de la Plataforma Técnica CVS, sin cargos
                                        adicionales, en primera instancia.
                                  </p>
                            </div>
                          </div>
                        </div>
                    {/if}
                    {#if open3 == 6}
                        <div class="card" style="margin-bottom:2%;">
                          <div class="card-header" id="headingSix" style="padding:0;">
                            <h2 class="text-align-center" style="margin:0;padding:0;">
                              <p class="dropdown-header">
                                   ENTREGA DE PRECERTIFICACIÓN O CERTIFICACIÓN
                              </p>
                            </h2>
                          </div>
                          <div id="collapseSix" class="collapse show" aria-labelledby="headingSix" data-parent="#accordionCert">
                            <div class="card-body">
                                  <p class="text-content">
                                        La Precertificación se entrega contra el cumplimiento satisfactorio de los requerimientos de diseño y la
                                        obtención del permiso de edificación. <br><br>
                                        La Certificación se entrega contra el cumplimiento satisfactorio de los requerimientos de diseño y
                                        construcción, junto con la obtención de la recepción definitiva.
                                  </p>
                            </div>
                          </div>
                        </div>
                    {/if}
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 white-bg" style="overflow:hidden" bind:this={row4} id="about-section-2">
        <img src="./img/background-D.svg" alt="" class="background-left disabe-img">
        <div class="row">
            <img bind:this={row4Image} src="./img/certification/reloj.png" alt="" class="world03-base04-clock disabe-img" style="{row4Image ? `transform: translateX(${translate4Calculated/1700}px) rotate(${translate4Calculated/7000}deg)` : ''}">
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix">
                <h2 class="text-content title-content" style="margin-bottom:0;"> PLAZOS DE REVISIÓN </h2>
                <hr class="underline-content">
            </div>
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix">
                <p class="text-content section-3-text-width">
                    Una vez que el Asesor CVS envía la documentación a
                    revisión a través de la Plataforma de Gestión Documental, la
                    entidad administradora CTeC, contará con los
                    siguientes plazos para emitir su veredicto.
                </p>
                <div class="row icons-container center-small icons-container-section-3">
                    <img bind:this={item4} on:click={handleClickCertBase4One} class="icon-size clickable {open4 === 1 ? 'selected-box border-color-two' : ''}" src="./img/certification/icono1-mundo3-D.svg" alt="" >
                    <img on:click={handleClickCertBase4Two} class="icon-size clickable {open4 === 2 ? 'selected-box border-color-three' : ''}" src="./img/certification/icono2-mundo3-D.svg" alt="">
                </div>

                <div id="accordionCert2" style="margin:2vh 0;">
                    {#if open4 == 1}
                        <div class="card revision-height" style="margin-bottom:2%;">
                          <div class="card-header" id="headingOne-D" style="padding:0;">
                            <h2 class="text-align-center" style="margin:0;padding:0;">
                              <p class="dropdown-header">
                                  PRECERTIFICACIÓN
                              </p>
                            </h2>
                          </div>
                          <div id="collapseOne-D" class="collapse show" aria-labelledby="headingOne-D" data-parent="#accordionCert2">
                            <div class="card-body">
                                <table class="table table-striped">
                                  <thead>
                                    <tr style="background-color:#B3D680">
                                      <th scope="col">ACCIÓN DEL ASESOR CSV</th>
                                      <th scope="col">TAREA DE LA ENTIDAD ADMINISTRADORA</th>
                                      <th scope="col">PLAZO</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr style="background-color:#E7F2D9">
                                      <td>Primer envío de documentación</td>
                                      <td>Revisión de la documentación y emisión del primer informe técnico</td>
                                      <td>15 días hábiles</td>
                                    </tr>
                                    <tr style="background-color:#F6FAF2">
                                      <td>Envío de documentación para subsanar errores(en caso que se requiera)</td>
                                      <td>Revisión de la documentación y emisión del segundo informe técnico</td>
                                      <td>10 días hábiles</td>
                                    </tr>
                                  </tbody>
                                </table>
                            </div>
                          </div>
                        </div>
                    {/if}
                    {#if open4 == 2}
                        <div class="card" style="margin-bottom:2%;">
                          <div class="card-header" id="headingTwo-D" style="padding:0;">
                            <h2 class="text-align-center" style="margin:0;padding:0;">
                              <p class="dropdown-header">
                                  CERTIFICACIÓN
                              </p>
                            </h2>
                          </div>
                          <div id="collapseTwo-D" class="collapse show" aria-labelledby="headingTwo-D" data-parent="#accordionCert2">
                            <div class="card-body">
                            <table class="table table-striped">
                              <thead>
                                <tr style="background-color:#B3D680">
                                  <th scope="col">ACCIÓN DEL ASESOR CSV</th>
                                  <th scope="col">TAREA DE LA ENTIDAD ADMINISTRADORA</th>
                                  <th scope="col">PLAZO</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr style="background-color:#E7F2D9">
                                  <td>Primer envío de documentación</td>
                                  <td>Revisión de la documentación y emisión del primer informe técnico</td>
                                  <td>15 días hábiles</td>
                                </tr>
                                <tr style="background-color:#F6FAF2">
                                  <td>Envío de documentación para subsanar errores (en caso que se requiera)</td>
                                  <td>Revisión de la documentación y emisión del segundo informe técnico</td>
                                  <td>10 días hábiles</td>
                                </tr>
                                <tr style="background-color:#E7F2D9">
                                  <td>Solicitud de compra de placa de reconocimiento (en caso que se requiera)</td>
                                  <td>Confección de placa de reconocimiento</td>
                                  <td>5 días hábiles</td>
                                </tr>
                              </tbody>
                            </table>
                            </div>
                          </div>
                        </div>
                    {/if}
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 white-bg" style="overflow:hidden" bind:this={row5} id="about-section-3">
        <img src="./img/background-E.svg" alt="" class="background-right disabe-img">
        <div class="row">
            <img bind:this={row5Image} class="home-img-base03 disabe-img" src="./img/planta-paralaxC-1.png" alt="" style="{row5Image ? `transform: translateX(${-translate5Calculated/1200}px)` : ''}">
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix" style="height:min-content">

                <h2 class="text-content title-content" style="margin-bottom:0;"> COSTOS ASOCIADOS </h2>
                <hr class="underline-content">

                <p class="text-content text-width-4">
                    Un desarrollador inmobiliario deberá cubrir los
                    siguientes costos para certificar:
                </p>
                <div class="table-responsive">
                    <table class="table table-striped" id="certification-cost-table">
                        <thead>
                            <tr style="background-color:#B3D680;">
                            <th scope="col">CONCEPTO</th>
                            <th scope="col">PAGO A</th>
                            <th scope="col">A TRAVÉS DE</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style="background-color:#E7F2D9">
                            <td>Honorarios por asesoría para lograr la Certificación</td>
                            <td>Asesor CVS</td>
                            <td>Relación directa con Asesor CVS</td>
                            </tr>
                            <tr style="background-color:#F6FAF2">
                            <td>Inscripción del proyecto (a este valor se le debe agregar IVA)</td>
                            <td>Centro Tecnológico CTeC</td>
                            <td> Plataforma Técnica CVS</td>
                            </tr>
                            <tr style="background-color:#E7F2D9">
                            <td>Envío a revisión de la documentación recopilada por el Asesor CVS (a este valor se le debe agregar IVA)</td>
                            <td>Centro Tecnológico CTeC</td>
                            <td> Plataforma Técnica CVS</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <p class="text-content text-width-4">
                    Para obtener información detallada y actualizada
                    sobre los costos de certificación, por favor escribir a
                    contacto@cvschile.cl.
                </p>
                <p class="text-content" style="font-size:20pt;margin:0;"> TABLA DE COSTO DE CERTIFICACIÓN </p>
                <p class="text-content text-width-4" style="font-size:10pt;margin-top:0;">
                    (Costos referidos a los ítemes 2 y 3 descritos en la tabla anterior. Pagos a CTeC)
                </p>
                <div id="accordionCert3" class="flex-arrow"  style="margin:2vh 0;">
                        <div class="card" style="margin-bottom:2%;height: auto;">
                          <div  on:click={handleClickArrow1} class="card-header clickable" id="headingOne-E" style="padding:0;" data-toggle="collapse" data-target="#collapseOne-E" aria-expanded="true" aria-controls="collapseOne-E">
                            <h2 class="text-align-center table-with-number" style="margin:0;padding:0;">
                              <button class="btn btn-link dropdown-header">
                                  TABLA 1: PRECIO DECRECIENTE UNITARIO, POR RANGO DE VIVIENDAS PARA PROYECTOS EN ALTURA Y EXTENSIÓN
                              </button>
                              <div class="sort-arrow" >
                                  {#if up1 === false}<Icon class="arrow-top" icon={faSortUp}></Icon>{/if}
                                  {#if up1 === true}<Icon class="arrow-bot" icon={faSortDown}></Icon>{/if}
                              </div>
                            </h2>
                          </div>
                          <div id="collapseOne-E" class="collapse" aria-labelledby="headingOne-E" data-parent="#accordionCert3">
                            <div class="card-body">
                                <table class="table table-striped">
                                  <thead>
                                    <tr style="background-color:#B3D680">
                                      <th scope="col">RANGO</th>
                                      <th scope="col">PRECIO CERTIFICACIÓN POR UNIDAD DE VIVIENDA</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr style="background-color:#E7F2D9">
                                      <td>Viviendas de la 1 a la 5 </td>
                                      <td>UF 5,00 * unidad</td>
                                    </tr>
                                    <tr style="background-color:#F6FAF2">
                                      <td>Viviendas de la 6 a la 10 </td>
                                      <td>UF 3,00 * unidad adicional a rango anterior</td>
                                    </tr>
                                    <tr style="background-color:#E7F2D9">
                                      <td>Viviendas de la 11 a la 25</td>
                                      <td>UF 1,00 * unidad adicional a rango anterior</td>
                                    </tr>
                                    <tr style="background-color:#F6FAF2">
                                      <td>Viviendas de la 26 a la 100 </td>
                                      <td>UF 0,50 * unidad adicional a rango anterior</td>
                                    </tr>
                                    <tr style="background-color:#E7F2D9">
                                      <td>Viviendas de la 101 a la 200</td>
                                      <td>UF 0,30 * unidad adicional a rango anterior</td>
                                    </tr>
                                    <tr style="background-color:#F6FAF2">
                                      <td>Viviendas de la 201 en adelante </td>
                                      <td>UF 0,20 * unidad adicional a rango anterior</td>
                                    </tr>
                                  </tbody>
                                </table>
                            </div>
                          </div>
                        </div>
                        <div class="card" style="margin-bottom:2%;height: auto;">
                          <div  on:click={handleClickArrow2} class="card-header clickable" id="headingTwo-E" style="padding:0;" data-toggle="collapse" data-target="#collapseTwo-E" aria-expanded="true" aria-controls="collapseTwo-E">
                            <h2 class="text-align-center table-with-number" style="margin:0;padding:0;">
                              <button class="btn btn-link dropdown-header" style="" >
                                  TABLA 2: PRECIO DECRECIENTE UNITARIO, PARA PROYECTOS QUE CONSIDERAN SOLO UNA VIVIENDA
                              </button>
                              <div class="sort-arrow" >
                                  {#if up2 === false}<Icon class="arrow-top" icon={faSortUp}></Icon>{/if}
                                  {#if up2 === true}<Icon class="arrow-bot" icon={faSortDown}></Icon>{/if}
                              </div>
                            </h2>
                          </div>
                          <div id="collapseTwo-E" class="collapse" aria-labelledby="headingTwo-E" data-parent="#accordionCert3">
                            <div class="card-body">
                                <table class="table table-striped">
                                  <thead>
                                    <tr style="background-color:#B3D680">
                                      <th scope="col">RANGO</th>
                                      <th scope="col">PRECIO CERTIFICACIÓN POR SUPERFICIE</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr style="background-color:#E7F2D9">
                                      <td>0 a 60 m2</td>
                                      <td>UF 0,16 * m2</td>
                                    </tr>
                                    <tr style="background-color:#F6FAF2">
                                      <td>61 a 120 m2</td>
                                      <td>UF 0,15 * m2, adicional a rango anterior</td>
                                    </tr>
                                    <tr style="background-color:#E7F2D9">
                                      <td>121 a 200 m2</td>
                                      <td>UF 0,10 * m2, adicional a rango anterior</td>
                                    </tr>
                                    <tr style="background-color:#F6FAF2">
                                      <td>Sobre 200 m2</td>
                                      <td>UF 0,05 * m2, adicional a rango anterior</td>
                                    </tr>
                                  </tbody>
                                </table>
                            </div>
                          </div>
                        </div>
                </div>
                <p class="text-content" style="font-size:20px;margin-top:5vh;"> DESGLOSE DEL COSTO DE CERTIFICACIÓN </p>
                <p class="text-content text-width-4">
                        Del costo total de certificación, se desprenden los
                        siguientes pagos, al registrar el proyecto y en cada
                        fase de revisión. Todos los pagos se procesan a través
                        de la Plataforma de Gestión Documental de la CVS
                </p>
                <img src="./img/certification/graf-mundo3.svg" alt="" class="world03-base05-img">
            </div>
        </div>
    </div>
</div>

<style>

#accordionCert .card{
    height: 450px;
}

.left-arrow-pos{
    position: relative;
}

.section-3-text-width{
    width: 62%;
}

.world03-base02-img{
    top: 15%;
    height: 70%;
    position: absolute;
    right: 10%;
}

.world03-base05-img{
    height: 20%;
    width: 40%;
    margin-bottom: 5vh;
}

.icons-container-section-3{
    max-width: 670px;
    margin: 0 -10px;
    width: calc(100% + 20px);
}

.icons-container-section-3 .icon-size{
    margin: 10px;
}

.collapse .card-body .text-content{
    margin: 0;
}

.collapse .card-body table thead tr th, .collapse .card-body table tbody tr td{
    border: 2px solid white;
}

#accordionCert2 .card{
    height: 360px;
    width: 62%;
}

.background-right{
    right: 0;
    position: absolute;
    height: 100%;
    max-height: 100vh;
}

.background-left{
    left: 0;
    position: absolute;
    height: 100%;
    max-height: 100vh;
}

.world03-base01-hand{
    position: absolute;
    height: 72%;
    left: 52%;
    top: 28%;
}

.base02-text-margin{
    margin-bottom: 15vh;
}

.text-width-4{
    width: 40%;
}

.padding-fix{
    padding:0 8px;
}

.info-box{
    text-align-last: center;
    width: 60%;
    background-image: url("../img/caja-mas-info.svg");
    background-repeat: no-repeat;
    margin-top: 5vh;
    padding-right: 5vh;
}

#info-box-text{
    font-size: 12pt;
    margin-top: 1.5vh;
    font-weight: bold;
}

#info-box-img{
    height: 6vh;
    margin-bottom: 4vh;
}




@media (max-width: 992px){
    #info-box-img{
        margin-top: 5vh;
        margin-bottom: 0;
    }
    .info-box{
        padding-right: 0;
    }

}

@media (max-width: 1750px){
    .info-box{
        width: 75%;
    }
}


@media (max-width: 1400px){
    .card{
        height: auto;
    }
    .icons-container{
        justify-content: center;
    }
    .disabe-img {
        display:none;
    }
    .text-width-4{
        width: 100%;
    }
    .padding-fix{
        padding:0 15px;
    }
    .base02-text-margin{
        margin-bottom: 5vh;
    }
    #accordionCert .card, #accordionCert2 .card{
        width: 100%;
        height: auto;
    }
    .info-box{
        width: 100%;
        background-image: none;
    }
    .section-3-text-width{
        width: 100%;
    }
}

.white-bg{
    background-color: white;
    overflow: hidden;
}

.dropdown-header{
    font-size: 20pt;
    line-height: 21pt;
    text-align: justify;
    color: rgb(0, 99, 175);
    font-family: 'suga-pro';
    padding: 6px 12px 6px 12px;
    white-space: pre-wrap;
}

@media (max-width: 576px){
    .world03-base05-img{
        width: inherit;
    }
    .left-arrow-pos{
        position: absolute;
    }
}

.world03-base04-clock{
    position: absolute;
    bottom: 0;
    height: 74%;
    right: 0;
}

.card-header{
    background-color: rgb(241,245,234);
}

.table-with-number .dropdown-header{
    font-family:'DINPro-Bold';
    font-size: 17pt;
    white-space: pre-wrap;
}

.home-img-base03{
    position: absolute;
    right: 0;
    height: 100vh;
}

.carousel-img{
    height: 20vh;
}

.selected-box{
    padding: 5px;
}
.selected-box.border-color-one{
    border: 1px solid #4ba99b;
}
.selected-box.border-color-two{
    border: 1px solid #9bc52c;
}
.selected-box.border-color-three{
    border: 1px solid #95c11f;
}

table{
    font-size: 12pt !important;
    font-family: 'DINPro-Regular';
    color: #006937;
}

table thead {
    font-size: 15px !important;
    font-family: 'suga-pro';
    color: #006937;
    background-color: #BAD76E;
}

table tbody tr.odd td{
    background-color: #ECF4D7;
}

table tbody tr.even td{
    background-color: #F9FBF2;
}

.sort-arrow {
    margin-left: auto;
}


.sort-arrow :global(.arrow-bot) {
    margin-bottom:13px;
    pointer-events: none;
}

.sort-arrow :global(.arrow-top) {
    margin-top:13px;
    pointer-events: none;
}

.flex-arrow .card-header h2{
    display: flex;
}

.link-color{
    color: #95c121;
}

#accordionCert2 .card{
    overflow: auto;
}

@media (max-width: 430px){
    #accordionCert2 .card .card-header{
        width: 125%;
    }
}

</style>
